import { createFileRoute } from "@tanstack/react-router";
import { PlaceholderShell } from "@/components/admin/PlaceholderShell";
import { AdminSubNav, CHATBOT_TABS } from "@/components/admin/AdminSubNav";

export const Route = createFileRoute("/admin/chatbot/review")({
  head: () => ({
    meta: [
      { title: "Review queue · Admin" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: ChatbotReview,
});

function ChatbotReview() {
  return (
    <div>
      <AdminSubNav tabs={CHATBOT_TABS} />
      <PlaceholderShell
        title="Review queue"
        description="Answers flagged as low confidence or potentially non-compliant."
        checklist={[
        "Low-confidence answer queue",
        "Compliance keyword flags",
        "Approve, edit, or discard",
        "Feed corrections into training",
        ]}
      />
    </div>
  );
}
